export const routesPath = {
  register: '/register',
  login: '/login',
  user: 'user',
  news: 'news',
  notices: 'notices',
  friends: 'friends',
  noticesCat: 'notices/:categoryName',
  cantegoryName: ':categoryName',
  sell: 'sell',
};
